import React from "react";

/**
 * A padlock standing against the canvas edge it holds.
 *
 * The bar is the side of the viewport the image is pinned to, which is what
 * separates Lock Left from Lock Right in the menu; `open` drops the shackle and
 * the bar for the plain "unlock" action, which belongs to no side.
 */
const AlignmentLock = ({ color, side = null, open = false }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {side === "left" && <line x1="2" y1="3" x2="2" y2="21" />}
      {side === "right" && <line x1="22" y1="3" x2="22" y2="21" />}
      <rect x="6" y="11" width="12" height="9" rx="2" />
      <path d={open ? "M9 11V7a3 3 0 0 1 6 0" : "M9 11V7a3 3 0 0 1 6 0v4"} />
    </svg>
  );
};

export default AlignmentLock;
